"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: similar_listings.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarListing = exports.SimilarListingsResponse = exports.SimilarListingsRequest = exports.LocationSimilarListingsRequest_Coordinates = exports.LocationSimilarListingsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const integer_range_1 = require("../common/integer_range");
const timestamp_1 = require("../google/protobuf/timestamp");
const display_1 = require("../property/display");
const listing_type_1 = require("../property/listing_type");
const provider_1 = require("../property/provider");
const standard_status_1 = require("../property/standard_status");
const status_legacy_1 = require("../property/status_legacy");
exports.protobufPackage = "domain";
function createBaseLocationSimilarListingsRequest() {
    return {
        position: undefined,
        homeType: "",
        bedrooms: 0,
        bathrooms: 0,
        sqft: 0,
        size: 0,
        statusId: 0,
        minPrice: 0,
        maxPrice: 0,
        isRental: false,
        standardStatus: 0,
    };
}
exports.LocationSimilarListingsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.position !== undefined) {
            exports.LocationSimilarListingsRequest_Coordinates.encode(message.position, writer.uint32(10).fork()).join();
        }
        if (message.homeType !== "") {
            writer.uint32(18).string(message.homeType);
        }
        if (message.bedrooms !== 0) {
            writer.uint32(24).int32(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(32).int32(message.bathrooms);
        }
        if (message.sqft !== 0) {
            writer.uint32(40).int32(message.sqft);
        }
        if (message.size !== 0) {
            writer.uint32(48).uint32(message.size);
        }
        if (message.statusId !== 0) {
            writer.uint32(56).int32(message.statusId);
        }
        if (message.minPrice !== 0) {
            writer.uint32(64).uint32(message.minPrice);
        }
        if (message.maxPrice !== 0) {
            writer.uint32(72).uint32(message.maxPrice);
        }
        if (message.isRental !== false) {
            writer.uint32(80).bool(message.isRental);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(88).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocationSimilarListingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.position = exports.LocationSimilarListingsRequest_Coordinates.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.homeType = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.bedrooms = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.bathrooms = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.sqft = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.size = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.minPrice = reader.uint32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.maxPrice = reader.uint32();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.isRental = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            position: isSet(object.position)
                ? exports.LocationSimilarListingsRequest_Coordinates.fromJSON(object.position)
                : undefined,
            homeType: isSet(object.homeType) ? globalThis.String(object.homeType) : "",
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            sqft: isSet(object.sqft) ? globalThis.Number(object.sqft) : 0,
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
            statusId: isSet(object.statusId) ? (0, status_legacy_1.statusLegacyFromJSON)(object.statusId) : 0,
            minPrice: isSet(object.minPrice) ? globalThis.Number(object.minPrice) : 0,
            maxPrice: isSet(object.maxPrice) ? globalThis.Number(object.maxPrice) : 0,
            isRental: isSet(object.isRental) ? globalThis.Boolean(object.isRental) : false,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== undefined) {
            obj.position = exports.LocationSimilarListingsRequest_Coordinates.toJSON(message.position);
        }
        if (message.homeType !== "") {
            obj.homeType = message.homeType;
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.sqft !== 0) {
            obj.sqft = Math.round(message.sqft);
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        if (message.statusId !== 0) {
            obj.statusId = (0, status_legacy_1.statusLegacyToJSON)(message.statusId);
        }
        if (message.minPrice !== 0) {
            obj.minPrice = Math.round(message.minPrice);
        }
        if (message.maxPrice !== 0) {
            obj.maxPrice = Math.round(message.maxPrice);
        }
        if (message.isRental !== false) {
            obj.isRental = message.isRental;
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.LocationSimilarListingsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseLocationSimilarListingsRequest();
        message.position = (object.position !== undefined && object.position !== null)
            ? exports.LocationSimilarListingsRequest_Coordinates.fromPartial(object.position)
            : undefined;
        message.homeType = (_a = object.homeType) !== null && _a !== void 0 ? _a : "";
        message.bedrooms = (_b = object.bedrooms) !== null && _b !== void 0 ? _b : 0;
        message.bathrooms = (_c = object.bathrooms) !== null && _c !== void 0 ? _c : 0;
        message.sqft = (_d = object.sqft) !== null && _d !== void 0 ? _d : 0;
        message.size = (_e = object.size) !== null && _e !== void 0 ? _e : 0;
        message.statusId = (_f = object.statusId) !== null && _f !== void 0 ? _f : 0;
        message.minPrice = (_g = object.minPrice) !== null && _g !== void 0 ? _g : 0;
        message.maxPrice = (_h = object.maxPrice) !== null && _h !== void 0 ? _h : 0;
        message.isRental = (_j = object.isRental) !== null && _j !== void 0 ? _j : false;
        message.standardStatus = (_k = object.standardStatus) !== null && _k !== void 0 ? _k : 0;
        return message;
    },
};
function createBaseLocationSimilarListingsRequest_Coordinates() {
    return { coordinates: [], type: "" };
}
exports.LocationSimilarListingsRequest_Coordinates = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        writer.uint32(10).fork();
        for (const v of message.coordinates) {
            writer.double(v);
        }
        writer.join();
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocationSimilarListingsRequest_Coordinates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag === 9) {
                        message.coordinates.push(reader.double());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.coordinates.push(reader.double());
                        }
                        continue;
                    }
                    break;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            coordinates: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.coordinates)
                ? object.coordinates.map((e) => globalThis.Number(e))
                : [],
            type: isSet(object.type) ? globalThis.String(object.type) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.coordinates) === null || _a === void 0 ? void 0 : _a.length) {
            obj.coordinates = message.coordinates;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return exports.LocationSimilarListingsRequest_Coordinates.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseLocationSimilarListingsRequest_Coordinates();
        message.coordinates = ((_a = object.coordinates) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSimilarListingsRequest() {
    return { pageSize: 0, statusId: 0, minPrice: 0, maxPrice: 0, standardStatus: 0 };
}
exports.SimilarListingsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pageSize !== 0) {
            writer.uint32(8).uint32(message.pageSize);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.minPrice !== 0) {
            writer.uint32(24).uint32(message.minPrice);
        }
        if (message.maxPrice !== 0) {
            writer.uint32(32).uint32(message.maxPrice);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(40).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimilarListingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pageSize = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.minPrice = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.maxPrice = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
            statusId: isSet(object.statusId) ? (0, status_legacy_1.statusLegacyFromJSON)(object.statusId) : 0,
            minPrice: isSet(object.minPrice) ? globalThis.Number(object.minPrice) : 0,
            maxPrice: isSet(object.maxPrice) ? globalThis.Number(object.maxPrice) : 0,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pageSize !== 0) {
            obj.pageSize = Math.round(message.pageSize);
        }
        if (message.statusId !== 0) {
            obj.statusId = (0, status_legacy_1.statusLegacyToJSON)(message.statusId);
        }
        if (message.minPrice !== 0) {
            obj.minPrice = Math.round(message.minPrice);
        }
        if (message.maxPrice !== 0) {
            obj.maxPrice = Math.round(message.maxPrice);
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.SimilarListingsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseSimilarListingsRequest();
        message.pageSize = (_a = object.pageSize) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.minPrice = (_c = object.minPrice) !== null && _c !== void 0 ? _c : 0;
        message.maxPrice = (_d = object.maxPrice) !== null && _d !== void 0 ? _d : 0;
        message.standardStatus = (_e = object.standardStatus) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
function createBaseSimilarListingsResponse() {
    return { data: [] };
}
exports.SimilarListingsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.data) {
            exports.SimilarListing.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimilarListingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.data.push(exports.SimilarListing.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map((e) => exports.SimilarListing.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.data) === null || _a === void 0 ? void 0 : _a.length) {
            obj.data = message.data.map((e) => exports.SimilarListing.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SimilarListingsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSimilarListingsResponse();
        message.data = ((_a = object.data) === null || _a === void 0 ? void 0 : _a.map((e) => exports.SimilarListing.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSimilarListing() {
    return {
        id: 0,
        mls: "",
        slug: "",
        address: "",
        listingType: 0,
        price: 0,
        soldPrice: 0,
        statusId: 0,
        providerId: 0,
        position: "",
        bedrooms: 0,
        bathrooms: 0,
        brokerage: "",
        squareFootage: undefined,
        termsOfUseRequired: false,
        imageRootStorageKey: "",
        createdAt: undefined,
        soldAt: undefined,
        isRental: false,
        bedroomsPartial: 0,
        bathroomsPartial: 0,
        updatedOn: undefined,
        streetName: "",
        streetNumber: "",
        unit: "",
        subDivision: "",
        province: "",
        imageSource: "",
        lastStatus: "",
        addressPath: "",
        expAgentId: 0,
        standardStatus: 0,
        displayAddress: undefined,
    };
}
exports.SimilarListing = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.mls !== "") {
            writer.uint32(18).string(message.mls);
        }
        if (message.slug !== "") {
            writer.uint32(26).string(message.slug);
        }
        if (message.address !== "") {
            writer.uint32(34).string(message.address);
        }
        if (message.listingType !== 0) {
            writer.uint32(40).int32(message.listingType);
        }
        if (message.price !== 0) {
            writer.uint32(53).float(message.price);
        }
        if (message.soldPrice !== 0) {
            writer.uint32(61).float(message.soldPrice);
        }
        if (message.statusId !== 0) {
            writer.uint32(64).int32(message.statusId);
        }
        if (message.providerId !== 0) {
            writer.uint32(72).int32(message.providerId);
        }
        if (message.position !== "") {
            writer.uint32(82).string(message.position);
        }
        if (message.bedrooms !== 0) {
            writer.uint32(88).uint64(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(96).uint64(message.bathrooms);
        }
        if (message.brokerage !== "") {
            writer.uint32(106).string(message.brokerage);
        }
        if (message.squareFootage !== undefined) {
            integer_range_1.IntegerRange.encode(message.squareFootage, writer.uint32(114).fork()).join();
        }
        if (message.termsOfUseRequired !== false) {
            writer.uint32(120).bool(message.termsOfUseRequired);
        }
        if (message.imageRootStorageKey !== "") {
            writer.uint32(130).string(message.imageRootStorageKey);
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(138).fork()).join();
        }
        if (message.soldAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.soldAt), writer.uint32(146).fork()).join();
        }
        if (message.isRental !== false) {
            writer.uint32(152).bool(message.isRental);
        }
        if (message.bedroomsPartial !== 0) {
            writer.uint32(160).uint64(message.bedroomsPartial);
        }
        if (message.bathroomsPartial !== 0) {
            writer.uint32(168).uint64(message.bathroomsPartial);
        }
        if (message.updatedOn !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updatedOn), writer.uint32(178).fork()).join();
        }
        if (message.streetName !== "") {
            writer.uint32(186).string(message.streetName);
        }
        if (message.streetNumber !== "") {
            writer.uint32(194).string(message.streetNumber);
        }
        if (message.unit !== "") {
            writer.uint32(202).string(message.unit);
        }
        if (message.subDivision !== "") {
            writer.uint32(210).string(message.subDivision);
        }
        if (message.province !== "") {
            writer.uint32(218).string(message.province);
        }
        if (message.imageSource !== "") {
            writer.uint32(226).string(message.imageSource);
        }
        if (message.lastStatus !== "") {
            writer.uint32(234).string(message.lastStatus);
        }
        if (message.addressPath !== "") {
            writer.uint32(242).string(message.addressPath);
        }
        if (message.expAgentId !== 0) {
            writer.uint32(248).uint64(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(256).int32(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            display_1.Display.encode(message.displayAddress, writer.uint32(266).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSimilarListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.address = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.price = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 61) {
                        break;
                    }
                    message.soldPrice = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.position = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.bedrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 12: {
                    if (tag !== 96) {
                        break;
                    }
                    message.bathrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.brokerage = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.squareFootage = integer_range_1.IntegerRange.decode(reader, reader.uint32());
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.termsOfUseRequired = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.imageRootStorageKey = reader.string();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.createdAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.soldAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.isRental = reader.bool();
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.bedroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.bathroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.updatedOn = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.streetName = reader.string();
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.streetNumber = reader.string();
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.unit = reader.string();
                    continue;
                }
                case 26: {
                    if (tag !== 210) {
                        break;
                    }
                    message.subDivision = reader.string();
                    continue;
                }
                case 27: {
                    if (tag !== 218) {
                        break;
                    }
                    message.province = reader.string();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.imageSource = reader.string();
                    continue;
                }
                case 29: {
                    if (tag !== 234) {
                        break;
                    }
                    message.lastStatus = reader.string();
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.addressPath = reader.string();
                    continue;
                }
                case 31: {
                    if (tag !== 248) {
                        break;
                    }
                    message.expAgentId = longToNumber(reader.uint64());
                    continue;
                }
                case 32: {
                    if (tag !== 256) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
                case 33: {
                    if (tag !== 266) {
                        break;
                    }
                    message.displayAddress = display_1.Display.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            address: isSet(object.address) ? globalThis.String(object.address) : "",
            listingType: isSet(object.listingType) ? (0, listing_type_1.listingTypeFromJSON)(object.listingType) : 0,
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            soldPrice: isSet(object.soldPrice) ? globalThis.Number(object.soldPrice) : 0,
            statusId: isSet(object.statusId) ? (0, status_legacy_1.statusLegacyFromJSON)(object.statusId) : 0,
            providerId: isSet(object.providerId) ? (0, provider_1.providerFromJSON)(object.providerId) : 0,
            position: isSet(object.position) ? globalThis.String(object.position) : "",
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            brokerage: isSet(object.brokerage) ? globalThis.String(object.brokerage) : "",
            squareFootage: isSet(object.squareFootage) ? integer_range_1.IntegerRange.fromJSON(object.squareFootage) : undefined,
            termsOfUseRequired: isSet(object.termsOfUseRequired) ? globalThis.Boolean(object.termsOfUseRequired) : false,
            imageRootStorageKey: isSet(object.imageRootStorageKey) ? globalThis.String(object.imageRootStorageKey) : "",
            createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
            soldAt: isSet(object.soldAt) ? fromJsonTimestamp(object.soldAt) : undefined,
            isRental: isSet(object.isRental) ? globalThis.Boolean(object.isRental) : false,
            bedroomsPartial: isSet(object.bedroomsPartial) ? globalThis.Number(object.bedroomsPartial) : 0,
            bathroomsPartial: isSet(object.bathroomsPartial) ? globalThis.Number(object.bathroomsPartial) : 0,
            updatedOn: isSet(object.updatedOn) ? fromJsonTimestamp(object.updatedOn) : undefined,
            streetName: isSet(object.streetName) ? globalThis.String(object.streetName) : "",
            streetNumber: isSet(object.streetNumber) ? globalThis.String(object.streetNumber) : "",
            unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
            subDivision: isSet(object.subDivision) ? globalThis.String(object.subDivision) : "",
            province: isSet(object.province) ? globalThis.String(object.province) : "",
            imageSource: isSet(object.imageSource) ? globalThis.String(object.imageSource) : "",
            lastStatus: isSet(object.lastStatus) ? globalThis.String(object.lastStatus) : "",
            addressPath: isSet(object.addressPath) ? globalThis.String(object.addressPath) : "",
            expAgentId: isSet(object.expAgentId) ? globalThis.Number(object.expAgentId) : 0,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
            displayAddress: isSet(object.displayAddress) ? display_1.Display.fromJSON(object.displayAddress) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.address !== "") {
            obj.address = message.address;
        }
        if (message.listingType !== 0) {
            obj.listingType = (0, listing_type_1.listingTypeToJSON)(message.listingType);
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.soldPrice !== 0) {
            obj.soldPrice = message.soldPrice;
        }
        if (message.statusId !== 0) {
            obj.statusId = (0, status_legacy_1.statusLegacyToJSON)(message.statusId);
        }
        if (message.providerId !== 0) {
            obj.providerId = (0, provider_1.providerToJSON)(message.providerId);
        }
        if (message.position !== "") {
            obj.position = message.position;
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.brokerage !== "") {
            obj.brokerage = message.brokerage;
        }
        if (message.squareFootage !== undefined) {
            obj.squareFootage = integer_range_1.IntegerRange.toJSON(message.squareFootage);
        }
        if (message.termsOfUseRequired !== false) {
            obj.termsOfUseRequired = message.termsOfUseRequired;
        }
        if (message.imageRootStorageKey !== "") {
            obj.imageRootStorageKey = message.imageRootStorageKey;
        }
        if (message.createdAt !== undefined) {
            obj.createdAt = message.createdAt.toISOString();
        }
        if (message.soldAt !== undefined) {
            obj.soldAt = message.soldAt.toISOString();
        }
        if (message.isRental !== false) {
            obj.isRental = message.isRental;
        }
        if (message.bedroomsPartial !== 0) {
            obj.bedroomsPartial = Math.round(message.bedroomsPartial);
        }
        if (message.bathroomsPartial !== 0) {
            obj.bathroomsPartial = Math.round(message.bathroomsPartial);
        }
        if (message.updatedOn !== undefined) {
            obj.updatedOn = message.updatedOn.toISOString();
        }
        if (message.streetName !== "") {
            obj.streetName = message.streetName;
        }
        if (message.streetNumber !== "") {
            obj.streetNumber = message.streetNumber;
        }
        if (message.unit !== "") {
            obj.unit = message.unit;
        }
        if (message.subDivision !== "") {
            obj.subDivision = message.subDivision;
        }
        if (message.province !== "") {
            obj.province = message.province;
        }
        if (message.imageSource !== "") {
            obj.imageSource = message.imageSource;
        }
        if (message.lastStatus !== "") {
            obj.lastStatus = message.lastStatus;
        }
        if (message.addressPath !== "") {
            obj.addressPath = message.addressPath;
        }
        if (message.expAgentId !== 0) {
            obj.expAgentId = Math.round(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            obj.displayAddress = display_1.Display.toJSON(message.displayAddress);
        }
        return obj;
    },
    create(base) {
        return exports.SimilarListing.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
        const message = createBaseSimilarListing();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.mls = (_b = object.mls) !== null && _b !== void 0 ? _b : "";
        message.slug = (_c = object.slug) !== null && _c !== void 0 ? _c : "";
        message.address = (_d = object.address) !== null && _d !== void 0 ? _d : "";
        message.listingType = (_e = object.listingType) !== null && _e !== void 0 ? _e : 0;
        message.price = (_f = object.price) !== null && _f !== void 0 ? _f : 0;
        message.soldPrice = (_g = object.soldPrice) !== null && _g !== void 0 ? _g : 0;
        message.statusId = (_h = object.statusId) !== null && _h !== void 0 ? _h : 0;
        message.providerId = (_j = object.providerId) !== null && _j !== void 0 ? _j : 0;
        message.position = (_k = object.position) !== null && _k !== void 0 ? _k : "";
        message.bedrooms = (_l = object.bedrooms) !== null && _l !== void 0 ? _l : 0;
        message.bathrooms = (_m = object.bathrooms) !== null && _m !== void 0 ? _m : 0;
        message.brokerage = (_o = object.brokerage) !== null && _o !== void 0 ? _o : "";
        message.squareFootage = (object.squareFootage !== undefined && object.squareFootage !== null)
            ? integer_range_1.IntegerRange.fromPartial(object.squareFootage)
            : undefined;
        message.termsOfUseRequired = (_p = object.termsOfUseRequired) !== null && _p !== void 0 ? _p : false;
        message.imageRootStorageKey = (_q = object.imageRootStorageKey) !== null && _q !== void 0 ? _q : "";
        message.createdAt = (_r = object.createdAt) !== null && _r !== void 0 ? _r : undefined;
        message.soldAt = (_s = object.soldAt) !== null && _s !== void 0 ? _s : undefined;
        message.isRental = (_t = object.isRental) !== null && _t !== void 0 ? _t : false;
        message.bedroomsPartial = (_u = object.bedroomsPartial) !== null && _u !== void 0 ? _u : 0;
        message.bathroomsPartial = (_v = object.bathroomsPartial) !== null && _v !== void 0 ? _v : 0;
        message.updatedOn = (_w = object.updatedOn) !== null && _w !== void 0 ? _w : undefined;
        message.streetName = (_x = object.streetName) !== null && _x !== void 0 ? _x : "";
        message.streetNumber = (_y = object.streetNumber) !== null && _y !== void 0 ? _y : "";
        message.unit = (_z = object.unit) !== null && _z !== void 0 ? _z : "";
        message.subDivision = (_0 = object.subDivision) !== null && _0 !== void 0 ? _0 : "";
        message.province = (_1 = object.province) !== null && _1 !== void 0 ? _1 : "";
        message.imageSource = (_2 = object.imageSource) !== null && _2 !== void 0 ? _2 : "";
        message.lastStatus = (_3 = object.lastStatus) !== null && _3 !== void 0 ? _3 : "";
        message.addressPath = (_4 = object.addressPath) !== null && _4 !== void 0 ? _4 : "";
        message.expAgentId = (_5 = object.expAgentId) !== null && _5 !== void 0 ? _5 : 0;
        message.standardStatus = (_6 = object.standardStatus) !== null && _6 !== void 0 ? _6 : 0;
        message.displayAddress = (object.displayAddress !== undefined && object.displayAddress !== null)
            ? display_1.Display.fromPartial(object.displayAddress)
            : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=similar_listings.js.map